module.exports = __webpack_public_path__ + "img/CRT_Weapon-Wand-01.7189ddca.png";